// Drawola: native language picker for views outside the editor. Fork-only.
//
// The Studio and its welcome render outside `<Excalidraw>`, so upstream's
// LanguageList (it reads the editor's isolated i18n store) cannot be used
// there. This one reads the app-level language atom and saves through the
// same manual selection action as the editor menu.

import React from "react";

import { useAtomValue, useSetAtom } from "../app-jotai";

import { appLangCodeAtom, selectAppLanguageAtom } from "./language-state";
import { productionLanguages } from "./languagePreference";

type AppLanguageSelectProps = {
  /** Class of the wrapping label; the text span gets `${className}-label`. */
  className: string;
  /** Translated visible label, which also names the select. */
  label: string;
};

/** A labeled native select of the production languages, by native name. */
export const AppLanguageSelect: React.FC<AppLanguageSelectProps> = ({
  className,
  label,
}) => {
  const langCode = useAtomValue(appLangCodeAtom);
  const selectLanguage = useSetAtom(selectAppLanguageAtom);

  return (
    <label className={className}>
      <span className={`${className}-label`}>{label}</span>
      <select
        value={langCode}
        onChange={(event) => selectLanguage(event.currentTarget.value)}
      >
        {productionLanguages().map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </label>
  );
};
